import { useSelector } from 'react-redux'
import { selectConfigParam } from '../store/selectors/config'

export const useConfigParam = (key: string) => {
  return useSelector(selectConfigParam(key))
}
